import { BrowserRouter } from 'react-router-dom';
import { Toaster } from '@yakit/ui-components';

import { VLDIframeModal } from '@VDL/components/VDLModals/VDLIframeModal';
import { VDLPassportModal } from '@VDL/components/VDLModals/VDLPassportModal';
import { ChatWidgetMFWrapper } from '@/components/ChatWidgetMFWrapper';

import { AppRouter } from '@VDL/router';
import { useVDLStore } from '@VDL/store/VDLstore';

import { useFetchYearsData } from '@VDL/hooks/useFetchYearsData';
import { useFetchLevelData } from '@VDL/hooks/useFetchLevelData';

const VDLContent = () => {
  const { selectedYear } = useVDLStore();

  useFetchYearsData();
  const { fetchData } = useFetchLevelData({ year: selectedYear });

  return (
    <>
      <AppRouter />
      <VLDIframeModal
        onClose={() => {
          if (!selectedYear) return;

          fetchData({ year: selectedYear });
        }}
      />
      <VDLPassportModal />
      <ChatWidgetMFWrapper
        baseURL="https://vdl.yakit.pro/v8/api/assistantvdl"
        variant="full"
      />
      <Toaster />
    </>
  );
};

const VDL = () => {
  return (
    <BrowserRouter basename={import.meta.env.ROUTER_BASENAME}>
      <VDLContent />
    </BrowserRouter>
  );
};

export default VDL;
